import React, { FC, useState } from 'react';
import CustomModal from '../../components/CustomModal';
import ProjectForm from '../../components/ProjectForm/index';
import CloseProjectTabs from '../../components/CloseProjectTabs';
import useTranslation from '../../hooks/useTranslation';
import { ProjectTypeModalProps } from '../../models/reusableProps/ProjectTypeModalProps';
import { useTypedSelector } from '../../store';
import {
  getBusinessUnits,
  getSelectedCountryCodes,
} from '../../store/selectData/selectors';
import { selectResponsibleOptionsList } from '../../store/users/selectors';
import { ESTABLISHMENT_TYPE } from '../../components/ProjectTypeSelect/utils';
import { selectConfidentialPermission } from '../../store/userData/selectors';
import {
  createProject,
  fetchSiteLocation,
} from '../../store/projects/actionWrapper';
import { useDispatch } from 'react-redux';
import { returnCloseValidationSchema } from './utils';
import { selectSiteLocation } from '../../store/projects/selectors';
import { calculateTabErrors } from '../CreateNewUnitModal/utils';

const CloseProjectModal: FC<ProjectTypeModalProps> = ({
  visible,
  onClose,
  projectsList,
  countries,
  setActiveProject,
}) => {
  const t = useTranslation();
  const isConfidentialAllowed = useTypedSelector(selectConfidentialPermission);
  const usersList = useTypedSelector(selectResponsibleOptionsList);
  const BuList = useTypedSelector(getBusinessUnits);
  const selectedSiteLocation = useTypedSelector(selectSiteLocation);
  const selectedCountryCodes = useTypedSelector(getSelectedCountryCodes);
  const [selectedCountry, setSelectedCountry] = React.useState('');
  const [formModified, setFormModified] = React.useState(false);
  const [formErrors, setFormErrors] = useState({});
  const validation = returnCloseValidationSchema(t);
  const dispatch = useDispatch();
  const handleCreateProject = (props) => {
    dispatch(
      createProject({
        ...props,
        establishmentType: ESTABLISHMENT_TYPE.CLOSE,
      }),
    );
    onClose();
  };

  const onCountryChange = (country) => {
    setSelectedCountry(country.target.value);
  };

  const BuFiltered = BuList.filter(
    (bu) =>
      bu.countryId === (selectedCountry || selectedCountryCodes[0]?.countryId),
  );
  const onBUChange = (bu) => {
    dispatch(fetchSiteLocation(bu.businessUnitId || ''));
  };

  return (
    <CustomModal
      isVisible={visible}
      useConfirmation
      formModified={formModified}
      onClose={onClose}
      title={t('projectTypes.close')}
      children={
        <ProjectForm
          onSubmit={handleCreateProject}
          setFormModified={(isDirty) => setFormModified(isDirty)}
          country={selectedCountryCodes[0]?.countryId}
          onClose={onClose}
          submitBtnTitle={t('common.create')}
          validationSchema={validation}
          selectedSiteLocation={selectedSiteLocation}
          projectType={ESTABLISHMENT_TYPE.CLOSE}
          setFormErrors={setFormErrors}
        >
          <CloseProjectTabs
            projectsList={projectsList}
            countries={countries}
            setActiveProject={setActiveProject}
            usersList={usersList}
            isConfidentialAllowed={isConfidentialAllowed}
            BuList={BuFiltered}
            onCountryChange={onCountryChange}
            onBUChange={onBUChange}
            tabErrors={calculateTabErrors(formErrors, false)}
          />
        </ProjectForm>
      }
    />
  );
};

export default CloseProjectModal;
